<script>
  import ChatConversaMensagemPropria from './ChatConversaMensagemPropria'
  import ChatConversaMensagemTerceiro from './ChatConversaMensagemTerceiro'
  export default{
    props: ['mensagem', 'currentUser'],
    name: 'chat-conversa-mensagem',
    data () {
      return {}
    },
    computed: {},
    mounted () {
    },
    destroyed () {},
    methods: {},
    components: {
      ChatConversaMensagemTerceiro,
      ChatConversaMensagemPropria
    }
  }
</script>

<template>
  <div>
    <chat-conversa-mensagem-terceiro v-if="mensagem.remetente.id !== currentUser.id" :mensagem="mensagem"></chat-conversa-mensagem-terceiro>
    <chat-conversa-mensagem-propria v-if="mensagem.remetente.id === currentUser.id" :mensagem="mensagem"></chat-conversa-mensagem-propria>
  </div>
</template>



// WEBPACK FOOTER //
// ChatConversaMensagem.vue?14183690